import state from './holidayset.state'
import mutations from './holidayset.mutations'
import actions from './holidayset.actions'
import getters from './holidayset.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/holidayset/holidayset.module.js
// module id = null
// module chunks = 